export const targetBaseUrl = "https://api.platform.indexar.tech"



// WEBPACK FOOTER //
// ./src/apiconfig.js